const DOCUMENTS_SEEN_PREFIX = 'rx-documents-seen:';

/**
 * Chaves do `localStorage` usadas pelo app. Centralizadas para que o logout
 * consiga apagar exatamente o que foi gravado.
 */
export const STORAGE_KEYS = {
  auth: 'rx-auth',
  queryCache: 'rx-query-cache',
  /** Empresa em que o usuário estava operando; volta à primeira da lista após o logout. */
  selectedCompany: 'rx-selected-company',
  /** Sobrevive ao logout: é o que detecta a troca de usuário no próximo login. */
  lastUserId: 'rx-last-user-id',
  /** Escritório do endereço. Sobrevive ao logout: pertence à origem, não ao usuário. */
  tenant: 'rx-tenant',
  /** Prefixo das últimas visitas ao feed de documentos; o logout apaga toda chave que começa por ele. */
  documentsSeenPrefix: DOCUMENTS_SEEN_PREFIX,
  /** Instante (ISO) da última visita ao feed de documentos da empresa: o que veio depois é "Novo". */
  documentsSeen: (clientId: number) => `${DOCUMENTS_SEEN_PREFIX}${clientId}`,
} as const;
